import EmptyFolderCTA from './EmptyFolderCTA';

export default EmptyFolderCTA;
